import { DateBuilder, isMissing, remodel } from '@imcc/utilities';
import { transform } from '../../../lib/transform';
import { ICognitoIdToken } from './i-cognito-id-token';
import { UserGroup } from './user-group.enum';

export class UserDto {
  static readonly externalUserPrefix = Object.freeze('ext_');

  groups?: string[];

  username?: string;

  businessunit?: string;

  company?: string;

  country?: string;

  department?: string;

  homesite?: string;

  langcode?: string;

  status?: string;

  email: string;

  emailVerified: boolean;

  exp: number;

  familyName?: string;

  givenName?: string;

  name?: string;

  authTime: number;

  sub: string;

  aud: string;

  atHash: string;

  iss: string;

  iat: string;

  expiresAt?: Date;

  static fromDecodedToken(token: ICognitoIdToken): UserDto {
    return transform(
      UserDto,
      remodel(token, {
        atHash: { from: 'at_hash' },
        aud: { from: 'aud' },
        authTime: { from: 'auth_time' },
        businessunit: { from: 'custom:ikeabusinessunit' },
        company: { from: 'custom:ikeacompany' },
        country: { from: 'custom:ikeacountry' },
        department: { from: 'custom:ikeadepartment' },
        email: { from: 'email' },
        emailVerified: { from: 'email_verified' },
        exp: { from: 'exp' },
        familyName: { from: 'family_name' },
        givenName: { from: 'given_name' },
        groups: { from: 'cognito:groups' },
        homesite: { from: 'custom:ikeahomesite' },
        iat: { from: 'iat' },
        iss: { from: 'iss' },
        langcode: { from: 'custom:ikealangcode' },
        name: { from: 'name' },
        status: { from: 'custom:ikeastatus' },
        sub: { from: 'sub' },
        username: { from: 'cognito:username' },
        expiresAt: {
          from: (o) => {
            if (isMissing(o['custom:ikeaexpiresat'])) {
              return undefined;
            }

            return new Date(o['custom:ikeaexpiresat']);
          },
        },
      }),
    );
  }

  get isAdministrator() {
    return this.isInGroup(UserGroup.administrator);
  }

  get isExternalUser() {
    const isExternalUser: boolean = this.isInGroup(UserGroup.external);

    return isExternalUser;
  }

  get isExpiring() {
    if (!this.expiresAt) {
      return false;
    }

    const currentDate = DateBuilder.fromCurrent.date;
    const expiryPeriodStart = new DateBuilder(this.expiresAt).addDays(-30).date;

    return currentDate > expiryPeriodStart && currentDate <= this.expiresAt;
  }

  isInGroup(group: UserGroup): boolean {
    return (this.groups || []).includes(group);
  }
}
